import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
function classForShadowSize(size, small, medium) {
    switch (size) {
        case 'sm':
            return small;
        case 'md':
            return medium;
        case undefined:
            return '';
        default:
            return assertUnreachableValue(size);
    }
}
/** Shadow class maps stay inside BoxPrimitive so product code uses its typed props. */
export function getBoxShadowClasses({ shadowSize: shadow, hoverShadow, shadowFocused = false, focusShadowOnPrimaryAction = false, shadowLayer, }) {
    switch (shadowLayer) {
        case 'overlay':
            return '';
        case 'box':
        case 'both':
            break;
        default:
            return assertUnreachableValue(shadowLayer);
    }
    const focused = shadowFocused
        ? classForShadowSize(shadow, 'shadow-sm-focus', 'shadow-md-focus')
        : '';
    if (focused)
        return focused;
    const idle = classForShadowSize(shadow, 'shadow-sm', 'shadow-md');
    const hover = classForShadowSize(hoverShadow, 'hover:shadow-sm-hover', 'hover:shadow-md-hover');
    const focus = focusShadowOnPrimaryAction
        ? classForShadowSize(shadow, 'has-[[data-shadow-primary-action]:focus]:shadow-sm-focus', 'has-[[data-shadow-primary-action]:focus]:shadow-md-focus')
        : '';
    return [idle, hover, focus].filter(Boolean).join(' ');
}
/** Paint the keyline above opaque children without adding a layout border. */
export function getBoxShadowOverlayClasses({ shadowSize: shadow, hoverShadow, shadowFocused = false, focusShadowOnPrimaryAction = false, shadowLayer, }) {
    switch (shadowLayer) {
        case 'box':
            return '';
        case 'overlay':
        case 'both':
            break;
        default:
            return assertUnreachableValue(shadowLayer);
    }
    const layer = 'after:pointer-events-none after:absolute after:inset-0 after:z-[2] after:rounded-inherit after:content-[""] after:transition-shadow after:duration-75 forced-colors:after:hidden';
    const focused = shadowFocused
        ? classForShadowSize(shadow, 'after:shadow-sm-focus', 'after:shadow-md-focus')
        : '';
    if (focused)
        return layer + ' ' + focused;
    const idle = classForShadowSize(shadow, 'after:shadow-sm', 'after:shadow-md');
    const hover = classForShadowSize(hoverShadow, 'hover:after:shadow-sm-hover', 'hover:after:shadow-md-hover');
    const focus = focusShadowOnPrimaryAction
        ? classForShadowSize(shadow, 'has-[[data-shadow-primary-action]:focus]:after:shadow-sm-focus', 'has-[[data-shadow-primary-action]:focus]:after:shadow-md-focus')
        : '';
    return [layer, idle, hover, focus].filter(Boolean).join(' ');
}
//# sourceMappingURL=boxShadowClasses.js.map